<template>
  <div class="work-order-detail">
    <el-row :gutter="20">
      <el-col :span="12">
        <work-order-status-info
          :work-order="wkDetailInfo"
        ></work-order-status-info>
        <work-order-base-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-base-info>
        <work-order-apply-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-apply-info>
        <work-order-user-info
          :work-order="wkDetailInfo"
          label-width="110px"
        ></work-order-user-info>
        <work-order-more-info
          :work-order="wkDetailInfo"
          label-width="110px"
          @refresh="getWorkDetail"
        ></work-order-more-info>
      </el-col>
      <el-col :span="12">
        <work-order-card :isShowHeader="false">
          <work-order-tool
            slot="card-body"
            :work-order="wkDetailInfo"
            @refresh="getWorkDetail"
          ></work-order-tool>
        </work-order-card>
        <el-card style="margin-bottom: 10px">
          <el-tabs v-model="isActive">
            <el-tab-pane label="回复" name="reply" v-if="!isCloseStatus">
              <template>
                <work-order-editor
                  ref="workOrderRef"
                  :configAttachmentsExpDate="true"
                ></work-order-editor>
                <div style="text-align: center">
                  <el-button
                    :loading="replayLoading"
                    @click="dealWorkOrderByIdNew"
                    size="small"
                    type="primary"
                  >
                    回复
                  </el-button>
                </div>
              </template>
            </el-tab-pane>
            <el-tab-pane label="标签" name="tag">
              <work-order-tag-info
                :work-order="wkDetailInfo"
                @change="getWorkDetail"
              ></work-order-tag-info>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card style="margin-bottom: 10px">
          <work-order-process :work-order="wkDetailInfo" :key="processKey"></work-order-process>
        </el-card>
      </el-col>
    </el-row>
    <temp-dialog></temp-dialog>
  </div>
</template>

<script>
import api from "plus/api";

export default {
  name: "work.mySubmit.detail",
  components: {},
  data() {
    return {
      loading: false,
      isActive: "reply",
      wkDetailInfo: {},
      replayLoading: false,
      optType: "process",
      processKey:0,
    };
  },
  computed: {
    wkOrderId() {
      return this.$route.query.wkOrderId;
    },
    id() {
      return this.$route.query.id;
    },
    workOrder() {
      return this.wkDetailInfo;
    },
    //待处理
    isAcceptStatus() {
      return this.workOrder && this.workOrder.status === 0;
    },
    //已处理
    isWaitForFeedStatus() {
      return this.workOrder && this.workOrder.status === 1;
    },
    //已关闭
    isCloseStatus() {
      return this.workOrder && this.workOrder.status === 2;
    },
    //处理中
    isProcessingStatus() {
      return this.workOrder && this.workOrder.status === 4;
    },
    userType() {
      const userType = new Map([
        ["work.myAccept.detail", "ACCEPTOR"],
        ["work.mySubmit.detail", "AUTHOR"],
        ["workmange.workQuality.detail", "MANAGER"],
        ["workmange.workOrderList.detail", "MANAGER"],
      ]);
      return userType.get(this.$route.name);
    },
  },
  activated() {
    this.getWorkDetail();
    this.processKey++;
  },
  deactivated() {
    this.resetData();
  },
  methods: {
    remind() {
      api.workmanage.remind(this.wkOrderId).then((res) => {
        this.$message.success("提醒成功！");
        this.getWorkDetail();
      });
    },
    resetData() {
      this.wkDetailInfo = {};
    },
    getWorkDetail() {
      return api.work
        .getWorkDetail({ id: this.id })
        .then((res) => {
          const data = res.data.data;
          this.wkDetailInfo = data;
          //已关闭状态没有回复标签组
          if (this.wkDetailInfo.status === 2) {
            this.isActive = "tag";
          }
        })
        .catch((err) => {});
    },
    closeWork() {
      this.$confirm(
        "关闭工单代表您对处理人的处理结果表示满意，若处理人未解决您的问题，请不要关闭工单。",
        "确认是否关闭工单",
        {
          confirmButtonText: "确定",
          confirmButtonClass: "confirmBtn",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          api.work
            .closeWork({
              wkOrderId: this.wkOrderId,
              optUserType: "AUTHOR",
            })
            .then((res) => {
              if (res.data.success) {
                this.getWorkDetail();
                this.$message.success("关闭成功！");
              }
            });
        })
        .catch((err) => {});
    },
    dealWorkOrderByIdNew() {
      this.replayLoading = true;
      try {
        const editorParams = this.$refs.workOrderRef.getData();
        if (!editorParams.remark) {
          return this.$message.warning("请填写反馈信息！");
        }
        const params = {
          workOrderId: this.wkOrderId,
          optUserType: this.userType,
          ...editorParams,
        };
        api.work
          .replyWorkOrder(params)
          .then((res) => {
            if (res.data.success) {
              this.$message.success("操作成功！");
              this.getWorkDetail();
              this.$refs.workOrderRef.clearData();
            }
          })
          .catch((err) => {});
      } finally {
        this.replayLoading = false;
      }
    },
    timestampToTime(timestamp) {
      const date = new Date(timestamp);
      const Y = date.getFullYear() + "-";
      const M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      const D = date.getDate() + " ";
      const h = date.getHours() + ":";
      const m = date.getMinutes() + ":";
      const s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    toRejectEdit() {
      this.$router.push({
        name: "work.submit.write",
        query: {
          qaTypeId: this.wkDetailInfo.qaTypeId,
          id: this.$route.query.id,
          wkOrderId: this.wkDetailInfo.wkOrderId,
          isEdit: "edit",
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.work-order-detail {
  width: 100%;

  .detail-header {
    width: 100%;
    background: #fff;
  }

  .quill-editor-container {
    .quill-editor-box {
      position: relative;

      .quill-editor {
        padding: 20px 47px 20px 95px;
        height: 365px;

        /deep/ .ql-container {
          height: calc(100% - 42px);
        }
      }

      .quill-text-limit {
        position: absolute;
        bottom: 30px;
        right: 60px;
        color: #888;
      }
    }

    .quill-editor-options-box {
      display: flex;
      justify-content: space-between;
      align-items: flex-end;
      padding-left: 95px;
      padding-right: 47px;

      .upload-file {
        font-size: 14px;

        .el-upload-list {
          padding-left: 78px;
        }

        .upload-img {
          display: flex;
          margin-top: 10px;

          .label {
            display: inline-block;
            width: 100px;
            margin-right: 12px;
            box-sizing: border-box;
            color: #3572e2;
          }
        }

        .upload-text-btn {
          color: #3572e2;
          margin-right: 12px;
        }

        .upload-limit {
          color: #999;
        }
      }
    }
  }

  .record {
    width: 100%;
    margin-top: 30px;

    .record-container {
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
}
</style>
